import { Injectable, signal } from '@angular/core';

export type FlashMessageType = 'success' | 'error' | 'warning';

export interface FlashMessage {
  type: FlashMessageType;
  text: string;
}

@Injectable({ providedIn: 'root' })
export class MessageService {
  readonly message = signal<FlashMessage | null>(null);
  private dismissTimer?: ReturnType<typeof setTimeout>;

  show(type: FlashMessageType, text: string, duration = 3000): void {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);
    this.message.set({ type, text });
    this.dismissTimer = setTimeout(() => this.dismiss(), duration);
  }

  success(text: string, duration = 3000): void {
    this.show('success', text, duration);
  }

  error(text: string, duration = 3000): void {
    this.show('error', text, duration);
  }

  warning(text: string, duration = 3000): void {
    this.show('warning', text, duration);
  }

  dismiss(): void {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);
    this.dismissTimer = undefined;
    this.message.set(null);
  }
}
